import Modal from "react-modal";
import * as S from "./styles";
import Close from "assets/close-small.svg";
import { IProduct } from "interfaces/Product";
import { DataTable } from "components/DataTable";
import { KeyValue } from "components/display/KeyValue";

interface ModalProps {
  modalIsOpen: boolean;
  setIsOpen: (value: boolean) => void;
  product?: IProduct;
}

export function MoreDetailsModal({
  modalIsOpen,
  product,
  setIsOpen,
}: ModalProps) {
  function closeModal() {
    setIsOpen(false);
  }

  console.log({ product });

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentElement={(props, children) => (
        <S.MoreDetailsProductContent {...props}>
          {children}
        </S.MoreDetailsProductContent>
      )}
      overlayElement={(props, contentElement) => (
        <S.ActiveOverlay {...props}>{contentElement}</S.ActiveOverlay>
      )}
    >
      <S.Header>
        <h2>Visualizando produto</h2> 
        <img src={Close} data-cy="close-modal-template" alt="fechar" onClick={closeModal} />
      </S.Header>
      <S.MoreContent>
        <S.Row>
          <KeyValue 
            label="Nome"
            value={product?.name}
          />

          <KeyValue 
            label="Descrição"
            value={product?.details}
          />

          <KeyValue 
            label="Tipo"
            value={product?.type}
          />
        </S.Row>

        <DataTable 
          data={product?.productRegions}
          headers={[
            { field: 'name', label: 'Nome' },
            { field: 'regionValue', label: 'Valor da região', renderColumn: (data) => data.regionValue.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })},
            { field: 'hourValue', label: 'Valor por hora excedente', renderColumn: (data) => data.hourValue.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            }) },
            { field: 'kmValue', label: 'Valor por KM excedente', renderColumn: (data) => data.kmValue.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            }) },
          ]}
        />
        {/* <div>
          {product?.productRegions?.map((region) => (
            <S.Regions key={region.id}>
              <label>{region.name}</label>
              <p>
                {region.regionValue.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </p>
            </S.Regions>
          ))}
        </div> */}
      </S.MoreContent>
    </Modal>
  );
}
